import { useModal, show, create } from "@ebay/nice-modal-react";

import ConfirmationModal from "ds/components/ConfirmationModal";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";

type BulkActionsNewDrawerResultsStepCloseConfirmationModalProps = {
  onConfirm: () => void;
};

const BulkActionsNewDrawerResultsStepCloseConfirmationModal = create(
  function BulkActionsNewDrawerResultsStepCloseConfirmationModal({
    onConfirm,
  }: BulkActionsNewDrawerResultsStepCloseConfirmationModalProps) {
    const modal = useModal();

    const handleConfirm = () => {
      modal.resolve();
      modal.hide();
      onConfirm();
    };

    return (
      <ConfirmationModal
        title="Stop performing"
        confirmationButtonLabel="Stop performing"
        onConfirm={handleConfirm}
      >
        <ConfirmationModalMessage>
          Are you sure you want to stop performing the selected actions? <br /> <br /> This will
          terminate the ongoing work on the remaining items.
        </ConfirmationModalMessage>
      </ConfirmationModal>
    );
  }
);

export const showBulkActionsNewDrawerResultsStepCloseConfirmationModal = (
  props: BulkActionsNewDrawerResultsStepCloseConfirmationModalProps
) => show(BulkActionsNewDrawerResultsStepCloseConfirmationModal, props);
